import axios from 'axios';

import { buildApiV2Url } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';

const setLandingVisibility = (collectionPath, entityId, { isEnabled }) =>
  axios
    .patch(buildApiV2Url(`${collectionPath}/${entityId}`), {
      landing_enabled: isEnabled,
    })
    .catch(generateApiError());

export default setLandingVisibility;
